import React from "react";
import { Bar } from "react-chartjs-2";

export default function CommodityGraph({ data }) {
  const options = {
    ...data.options,
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden", WebkitOverflowScrolling: "touch" }}>
      <div style={{ position: "relative", height: "300px", minWidth: "700px" }}>
        <Bar
          data={{
            labels: data.data.labels,
            datasets: data.data.datasets,
          }}
          options={options}
        />
      </div>
    </div>
  );
}
